export default {
  allEudrBatches: state => state.eudrBatches,
  eudrBatchesLoading: state => state.loading
}
